/**
 * Bento Gallery Design Tokens
 * 
 * Centralized design tokens for the bento grid gallery component.
 * These values align with the Figma design system and address page v2 specs.
 */

import { spacing } from 'design-system/tokens/spacing';

export const bentoTokens = {
  /** Gallery container height */
  height: '432px',
  
  /** Container spacing */
  container: {
    paddingTop: spacing.sm, // 4px
    paddingHorizontal: '34px',
    marginBottom: '20px',
  },
  
  /** Border radius for main images */
  borderRadius: {
    main: '24px',
    thumbnail: '12px',
  },
  
  /** Spacing between grid items */
  gap: spacing.md, // 8px
  
  /** Z-index layers */
  zIndex: {
    badges: 10,
    seeAll: 10,
  },
  
  /** Image sizes for Next.js Image optimization */
  imageSizes: {
    banner: '100vw',
    mainImage: '(max-width: 1440px) 65vw, 928px',
    splitMain: '(max-width: 1440px) 60vw, 864px',
    splitSide: '(max-width: 1440px) 40vw, 576px',
    thumbnail: '203px',
  },
  
  /** Grid column spans (out of 12) */
  gridColumns: {
    mainImage: 8,
    thumbnail: 2,
    splitMain: 7,  // 60%
    splitSide: 5,  // 40%
  },
  
  /** Overlay positioning */
  overlay: {
    badges: spacing.sm, // 4px
    seeAll: spacing.lg, // 12px
  },
} as const;

export type BentoTokens = typeof bentoTokens;
